import React from 'react'
import './Copyrightpolicy.css'

const SecurityPolicy = () => {
    return (
   <div>
            <div id="heading">
                <h3>Security Policy</h3>
            </div>
            <div class="conntent-conntainer">
                    
                </div>
            </div>
     
      

    )
}

export default SecurityPolicy
